{
  "dropzoneLabel": "Strefa upuszczania",
  "selectPlaceholder": "Wybierz element",
  "tableResizer": "Zmiana rozmiaru",
  "colorSwatchPicker": "Color swatches"
}
